if (!customElements.get('delufe-product')) {
  customElements.define('delufe-product', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.classList.add('is-ready');
      this.syncQuantity();
      this.galleryDebug();
      this.addEventListener('input', (event) => {
        if (event.target.name === 'quantity') this.syncQuantity();
        if (event.target.matches('[data-extra-quantity]')) this.syncExtras();
      }, { signal: this.events.signal });
      this.addEventListener('change', (event) => {
        if (event.target.name === 'quantity') this.syncQuantity(true);
        if (event.target.matches('[data-extra-quantity]')) this.syncExtras(true);
      }, { signal: this.events.signal });
      this.addEventListener('submit', (event) => {
        if (!event.target.matches('.product-purchase') || !this.querySelector('[data-extra-covers]')) return;
        event.preventDefault();
        this.addConfiguration(event.target);
      }, { signal: this.events.signal });
      this.addEventListener('click', (event) => {
        if ((this.cartPending || this.cartReviewRequired) && !event.target.closest('[data-cart-review] a')) { event.preventDefault(); return; }
        const extraButton = event.target.closest('[data-extra-change]');
        if (extraButton) {
          const input = this.querySelector(`#${CSS.escape(extraButton.getAttribute('aria-controls'))}`);
          if (input.disabled) return;
          this.syncExtras(true);
          const min = Number(input.dataset.min) || 1;
          const step = Number(input.dataset.step) || 1;
          input.value = extraButton.dataset.extraChange === '1'
            ? (input.valueAsNumber === 0 ? min : input.valueAsNumber + step)
            : (input.valueAsNumber <= min ? 0 : input.valueAsNumber - step);
          this.syncExtras(true);
          return;
        }
        const quantityButton = event.target.closest('[data-quantity-change]');
        if (quantityButton) {
          const input = this.querySelector('[name="quantity"]');
          this.syncQuantity(true);
          if (quantityButton.dataset.quantityChange === '1') input.stepUp();
          else input.stepDown();
          this.syncQuantity(true);
          return;
        }
        const link = event.target.closest('a');
        if (!link || !this.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.matches('[data-thumbnail]')) {
          const image = this.querySelector(link.getAttribute('href'));
          if (!image) return;
          event.preventDefault();
          this.querySelectorAll('.product-gallery__slide').forEach(slide => slide.classList.toggle('is-active', slide === image));
          this.querySelectorAll('[data-thumbnail]').forEach(thumb => thumb === link ? thumb.setAttribute('aria-current', 'true') : thumb.removeAttribute('aria-current'));
        } else if (link.matches('[data-option-link]')) {
          event.preventDefault();
          this.selectOption(link);
        }
      }, { signal: this.events.signal });
    }
    galleryDebug() {
      if (new URL(window.location.href).searchParams.get('gallery_debug') !== '1') return;
      const gallery = this.querySelector('.product-gallery');
      const source = gallery?.querySelector('[data-gallery-debug]');
      if (!source || gallery.querySelector('[data-gallery-debug-panel]')) return;
      try {
        const details = document.createElement('details');
        details.dataset.galleryDebugPanel = '';
        const summary = document.createElement('summary');
        summary.textContent = 'DeLuFe Galerie-Diagnose (nur mit gallery_debug=1)';
        const pre = document.createElement('pre');
        pre.style.whiteSpace = 'pre-wrap';
        pre.style.overflowWrap = 'anywhere';
        const data = JSON.parse(source.textContent);
        data.rendered_image_ids = [...gallery.querySelectorAll('.product-gallery__slide')].map(image => image.id);
        data.active_image_id = gallery.querySelector('.product-gallery__slide.is-active')?.id || null;
        data.thumbnail_count = gallery.querySelectorAll('[data-thumbnail]').length;
        pre.textContent = JSON.stringify(data, null, 2);
        details.append(summary, pre);
        gallery.append(details);
      } catch (error) {
        console.warn('DeLuFe: Galerie-Diagnose konnte nicht gelesen werden.', error);
      }
    }
    syncQuantity(normalize = false) {
      const input = this.querySelector('[name="quantity"]');
      if (!input) return;
      const min = Math.max(1, Number(input.min) || 1);
      const step = Number(input.step) || 1;
      const max = input.max ? Number(input.max) : Infinity;
      if (normalize) {
        const value = input.valueAsNumber;
        const rounded = Number.isFinite(value) ? min + Math.round((value - min) / step) * step : min;
        const ceiling = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
        input.value = Math.max(min, Math.min(ceiling, rounded));
      }
      this.querySelectorAll('[data-quantity-change]').forEach(button => {
        button.hidden = false;
        button.disabled = button.dataset.quantityChange === '1' ? input.valueAsNumber + step > max : input.valueAsNumber - step < min;
      });
      this.syncExtras();
    }
    syncExtras(normalize = false) {
      const extras = this.querySelector('[data-extra-covers]');
      if (!extras) return;
      extras.hidden = false;
      let extraTotal = 0;
      let valid = true;
      extras.querySelectorAll('[data-extra-quantity]').forEach(input => {
        const min = Number(input.dataset.min) || 1;
        const step = Number(input.dataset.step) || 1;
        const max = input.max ? Number(input.max) : Infinity;
        if (input.disabled) input.value = 0;
        if (normalize) {
          const value = input.valueAsNumber;
          const ceiling = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
          input.value = !Number.isFinite(value) || value <= 0 || ceiling < min ? 0 : Math.min(ceiling, Math.max(min, min + Math.round((value - min) / step) * step));
        }
        const value = input.valueAsNumber;
        const allowed = Number.isSafeInteger(value) && value >= 0 && value <= max && (value === 0 || (value >= min && (value - min) % step === 0));
        input.setCustomValidity(allowed ? '' : extras.dataset.quantityError);
        valid = valid && allowed;
        extraTotal += allowed ? value * Number(input.dataset.price) : 0;
        const buttons = input.closest('.product-quantity').querySelectorAll('[data-extra-change]');
        buttons.forEach(button => {
          const next = value === 0 ? min : value + step;
          button.disabled = input.disabled || (button.dataset.extraChange === '1' ? next > max : value <= 0);
        });
      });
      const quantity = this.querySelector('[name="quantity"]');
      const price = extras.dataset.bundlePrice;
      const total = Number(price) * quantity.valueAsNumber + extraTotal;
      const output = extras.querySelector('[data-configuration-total]');
      output.textContent = valid && quantity.checkValidity() && price !== '' && Number.isSafeInteger(total)
        ? new Intl.NumberFormat(extras.dataset.locale || 'de', { style: 'currency', currency: extras.dataset.currency }).format(total / 100)
        : '—';
    }
    async addConfiguration(form) {
      if (this.cartPending || this.cartReviewRequired || this.hasAttribute('aria-busy')) return;
      const extras = this.querySelector('[data-extra-covers]');
      this.syncQuantity(true);
      this.syncExtras();
      const extraInputs = [...extras.querySelectorAll('[data-extra-quantity]')];
      if (!form.reportValidity() || extraInputs.some(input => !input.reportValidity())) return;
      const data = new FormData(form);
      const variantId = Number(data.get('id'));
      const quantity = Number(data.get('quantity'));
      if (!Number.isSafeInteger(variantId) || variantId <= 0 || !Number.isSafeInteger(quantity) || quantity < 1) return;
      const items = [{ id: variantId, quantity }];
      extraInputs.forEach(input => {
        if (!input.disabled && input.valueAsNumber > 0) items.push({ id: Number(input.dataset.variantId), quantity: input.valueAsNumber });
      });
      this.cartPending = true;
      this.setAttribute('aria-busy', 'true');
      form.querySelector('[name="add"]').disabled = true;
      const error = this.querySelector('[data-error-message]');
      error.hidden = true;
      try {
        const response = await fetch(extras.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400 || !Array.isArray(result.items) || result.items.length === 0) {
          throw new Error(typeof result.description === 'string' ? result.description : extras.dataset.cartError);
        }
        window.location.assign(extras.dataset.cartUrl);
      } catch (err) {
        // A failed/uncertain add may have changed the cart. Never retry automatically.
        this.cartReviewRequired = true;
        error.textContent = `${err.message || ''} ${extras.dataset.cartError}`;
        error.hidden = false;
        const review = this.querySelector('[data-cart-review]');
        review.hidden = false;
        review.querySelector('a').focus();
      } finally {
        this.cartPending = false;
        this.removeAttribute('aria-busy');
      }
    }
    async selectOption(link) {
      if (this.cartPending || this.cartReviewRequired) return;
      this.request?.abort();
      const request = this.request = new AbortController();
      const url = new URL(link.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      let quantity = this.querySelector('[name="quantity"]').value;
      let extraQuantities;
      this.setAttribute('aria-busy', 'true');
      this.querySelector('[name="add"]').disabled = true;
      const error = this.querySelector('[data-error-message]');
      error.hidden = true;
      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('Section request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('delufe-product');
        if (!next || next.dataset.sectionId !== this.dataset.sectionId) throw new Error('Missing product section');
        if (request.signal.aborted) return;
        quantity = this.querySelector('[name="quantity"]').value;
        extraQuantities = new Map([...this.querySelectorAll('[data-extra-quantity]')].map(input => [input.dataset.variantId, input.value]));
        const gallery = this.querySelector('.product-gallery');
        const nextGallery = next.querySelector('.product-gallery');
        if (gallery?.dataset.grouped === 'true' && nextGallery?.dataset.grouped === 'true'
          && gallery.dataset.galleryKey === nextGallery.dataset.galleryKey
          && gallery.dataset.imageIds === nextGallery.dataset.imageIds) {
          // A filling-only change keeps both the active image and the existing image nodes.
          const diagnostic = gallery.querySelector('[data-gallery-debug]');
          const nextDiagnostic = nextGallery.querySelector('[data-gallery-debug]');
          if (diagnostic && nextDiagnostic) diagnostic.textContent = nextDiagnostic.textContent;
          gallery.querySelector('[data-gallery-debug-panel]')?.remove();
          nextGallery.replaceWith(gallery);
        }
        this.replaceChildren(...next.childNodes);
        this.dataset.variantId = next.dataset.variantId;
        const input = this.querySelector('[name="quantity"]');
        input.value = quantity;
        if (!input.checkValidity()) input.value = input.min || '1';
        this.querySelectorAll('[data-extra-quantity]').forEach(extra => {
          if (extraQuantities.has(extra.dataset.variantId)) extra.value = extraQuantities.get(extra.dataset.variantId);
        });
        this.syncQuantity();
        this.syncExtras(true);
        this.galleryDebug();
        this.querySelectorAll('[data-option-key]').forEach(el => { if (el.dataset.optionKey === link.dataset.optionKey) el.focus({ preventScroll: true }); });
        const location = new URL(window.location.href);
        location.searchParams.delete('option_values');
        location.searchParams.delete('variant');
        if (next.dataset.variantId) location.searchParams.set('variant', next.dataset.variantId);
        else location.searchParams.set('option_values', url.searchParams.get('option_values'));
        history.replaceState({}, '', location);
        this.querySelector('[data-selection-status]').textContent = `${this.querySelector('[data-price]').textContent.trim()} · ${this.querySelector('[data-availability]').textContent.trim()}`;
      } catch (err) {
        if (err.name === 'AbortError') return;
        error.textContent = this.dataset.error;
        error.hidden = false;
        const id = this.querySelector('[name="id"]');
        this.querySelector('[name="add"]').disabled = !id.value || id.disabled;
      } finally {
        if (this.request === request) this.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
    }
  });
}
